import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Button, ButtonGroup, CloseButton, Container, FloatingLabel, Form } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { login } from "../service/LoginService";
import { Typeahead } from 'react-bootstrap-typeahead';
import RegistOrLogin from './RegistOrLogin';

const Report = (props) => {
    async function sendReport(div,text,type,groupId){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/report/",{div:div,text:text,type:type,id:groupId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function textareaSizing(labelElementId,elementId){
        let labelElement = document.querySelector(labelElementId)
        labelElement.style.lineHeight = "20px"
        let lineHeight = labelElement.style.lineHeight.replace(/[^0-9.]+/,'')
        let n = labelElement.value.match(/\n/g)
        if(n === null){
            n = 1
        } else {
            n = n.length + 1
        }
        if(n <= 5){
            n = 5
        }
        labelElement.style.height = lineHeight * n + 30 + "px"
        document.querySelector(elementId).style.height = lineHeight * n + 30 + "px"
    }

    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const options = [
        {label:"過度な性的表現が含まれている(性表現を含む作品が全年齢として公開されているなど)",div:"1"},
        {label:"プライバシーまたは肖像権を侵害している",div:"2"},
        {label:"無断転載している",div:"3"},
        {label:"商業用の広告や宣伝、勧誘を目的とする情報が含まれている",div:"4"},
        {label:"過度なグロテスク表現が含まれている",div:"5"},
        {label:"児童ポルノまたは児童虐待に相当する表現が含まれている",div:"6"},
        {label:"その他、利用規約やガイドラインに違反している",div:"7"},
    ]
    const [selected,setSelected] = useState([])
    const [reportText,setReportText] = useState("")

    return (
        <Container>
            <Typeahead id="report" placeholder={t("common.select")}
            className="mb-3"
            clearButton={true}
            onChange={(selected) => {
                setSelected(selected)
            }}
            selected={selected}
            defaultSelected={[]}
            options={options}
            />
            <FloatingLabel controlId="report-form" label={t("common.detail")+" *"} className="mb-3 w-100"
                onInput={(e) => textareaSizing("#report-form",".report-form-textarea")} style={{lineHeight:"20px"}}>
                <Form.Control className="report-form-textarea" as="textarea" style={{height:"130px"}} required onChange={(e) => {
                    setReportText(e.currentTarget.value)
                }}/>
            </FloatingLabel>
            <FloatingLabel controlId="report-title" label={"Title"} className="mb-3">
                <Form.Control type="text" value={props.title} disabled />
            </FloatingLabel>
            <Button
            onClick={() => {
                if(reportText.trim().length === 0 || selected.length === 0){
                    alert(t("common.require"))
                    return
                }
                sendReport(selected[0].div,reportText,props.type,props.groupId).then(r => {
                    if(r.result){
                        props.dialog(t("common.info"),t("common.sent"))
                    } else {
                        alert(r.errors.join("\n"))
                    }
                })
            }}
            >{t("common.send")}</Button>
        </Container>
    )
}

export default Report;
